import { ReactNode } from 'react';
import { ClientDataType } from 'modules/queryBuilder/types';
import {
  AnonSession24,
  AppUninstall24,
  Complaint24,
  Custom24,
  EmailBounce24,
  EmailClick24,
  EmailOpen24,
  EmailSend24,
  EmailSendSkip24,
  EmbeddedClick24,
  EmbeddedImpression24,
  EmbeddedReceived24,
  EmbeddedSession24,
  HostedUnsubscribe24,
  InAppClick24,
  InAppClose24,
  InAppDelete24,
  InAppDelivered24,
  InAppOpen24,
  InAppRecall24,
  InAppSend24,
  InAppSendSkip24,
  InboxImpression24,
  InboxSession24,
  ListSubscribe24,
  ListUnsubscribe24,
  Purchase24,
  PushBounce24,
  PushOpen24,
  PushSend24,
  PushSendSkip24,
  SmsBounce24,
  SmsClick24,
  SmsReceived24,
  SmsSend24,
  SmsSendSkip24,
  SmsUsageInfo24,
  WebPushClick24,
  WebPushSend24,
  WebPushSendSkip24,
  WhatsAppLine24,
} from 'ui/icons/aurora/24px';
import { User16 } from 'ui/icons/aurora/16px';
import { NavJourneys24 } from 'ui/icons/aurora/24px/headerNav/NavJourneys24';

export const DATA_TYPE_TO_ICON: Record<ClientDataType, ReactNode> = {
  [ClientDataType.AnonSession]: <AnonSession24 />,
  [ClientDataType.Bounce]: <EmailBounce24 />,
  [ClientDataType.Click]: <EmailClick24 />,
  [ClientDataType.Complaint]: <Complaint24 />,
  [ClientDataType.CustomEvent]: <Custom24 />,
  [ClientDataType.EmbeddedClick]: <EmbeddedClick24 />,
  [ClientDataType.EmbeddedImpression]: <EmbeddedImpression24 />,
  [ClientDataType.EmbeddedReceived]: <EmbeddedReceived24 />,
  [ClientDataType.EmbeddedSession]: <EmbeddedSession24 />,
  [ClientDataType.HostedUnsubscribeClick]: <HostedUnsubscribe24 />,
  [ClientDataType.JourneyExit]: <NavJourneys24 />,
  [ClientDataType.InAppClick]: <InAppClick24 />,
  [ClientDataType.InAppClose]: <InAppClose24 />,
  [ClientDataType.InAppDelete]: <InAppDelete24 />,
  [ClientDataType.InAppDelivery]: <InAppDelivered24 />,
  [ClientDataType.InAppOpen]: <InAppOpen24 />,
  [ClientDataType.InAppRecall]: <InAppRecall24 />,
  [ClientDataType.InAppSend]: <InAppSend24 />,
  [ClientDataType.InAppSendSkip]: <InAppSendSkip24 />,
  [ClientDataType.InboxMessageImpression]: <InboxImpression24 />,
  [ClientDataType.InboxSession]: <InboxSession24 />,
  [ClientDataType.Open]: <EmailOpen24 />,
  [ClientDataType.Purchase]: <Purchase24 />,
  [ClientDataType.PushBounce]: <PushBounce24 />,
  [ClientDataType.PushOpen]: <PushOpen24 />,
  [ClientDataType.PushSend]: <PushSend24 />,
  [ClientDataType.PushSendSkip]: <PushSendSkip24 />,
  [ClientDataType.PushUninstall]: <AppUninstall24 />,
  [ClientDataType.SMSBounce]: <SmsBounce24 />,
  [ClientDataType.SMSClick]: <SmsClick24 />,
  [ClientDataType.SMSReceived]: <SmsReceived24 />,
  [ClientDataType.SMSSend]: <SmsSend24 />,
  [ClientDataType.SMSSendSkip]: <SmsSendSkip24 />,
  [ClientDataType.SMSUsageInfo]: <SmsUsageInfo24 />,
  [ClientDataType.Send]: <EmailSend24 />,
  [ClientDataType.SendSkip]: <EmailSendSkip24 />,
  [ClientDataType.Subscribe]: <ListSubscribe24 />,
  [ClientDataType.UnSubscribe]: <ListUnsubscribe24 />,
  [ClientDataType.User]: <User16 height={24} width={24} />,
  [ClientDataType.WebPushClick]: <WebPushClick24 />,
  [ClientDataType.WebPushSend]: <WebPushSend24 />,
  [ClientDataType.WebPushSendSkip]: <WebPushSendSkip24 />,
  [ClientDataType.WhatsAppBounce]: <WhatsAppLine24 />, // Design is making an icon for this
  [ClientDataType.WhatsAppClick]: <WhatsAppLine24 />, // Design is making an icon for this
  [ClientDataType.WhatsAppConversationOpened]: <WhatsAppLine24 />, // Design is making an icon for this
  [ClientDataType.WhatsAppDelivery]: <WhatsAppLine24 />, // Design is making an icon for this
  [ClientDataType.WhatsAppReceived]: <WhatsAppLine24 />, // Design is making an icon for this
  [ClientDataType.WhatsAppSeen]: <WhatsAppLine24 />, // Design is making an icon for this
  [ClientDataType.WhatsAppSend]: <WhatsAppLine24 />, // Design is making an icon for this
  [ClientDataType.WhatsAppSendSkip]: <WhatsAppLine24 />, // Design is making an icon for this
  [ClientDataType.WhatsAppUsageInfo]: <WhatsAppLine24 />, // Design is making an icon for this
};
